(function () {
  const inFlightEvents = new Map();

  function centsToMoney(value) {
    return Number((Number(value || 0) / 100).toFixed(2));
  }

  function buildGa4CartItem(item, index) {
    const price = typeof item.final_price !== "undefined" ? item.final_price : item.price;

    return {
      item_id: String(item.sku || item.variant_id || item.id || ""),
      item_name: item.product_title || item.title || "Produto",
      item_variant: item.variant_title || "",
      price: centsToMoney(price),
      quantity: Number(item.quantity || 1),
      index,
    };
  }

  function buildBeginCheckoutPayload(cart, selectedOption) {
    const items = Array.isArray(cart?.items) ? cart.items : [];

    return {
      currency: "BRL",
      value: centsToMoney(cart?.total_price),
      items: items.map(buildGa4CartItem),
      shipping_tier: selectedOption?.service_name || selectedOption?.draft_shipping_title || "",
    };
  }

  function buildEventFingerprint(cart, selectedOption) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    return JSON.stringify({
      token: cart?.token || "",
      total_price: cart?.total_price || 0,
      items: items.map((item) => [item.variant_id || item.id || "", item.quantity || 1]),
      shipping: selectedOption?.service_name || selectedOption?.draft_shipping_title || "",
    });
  }

  function createEventId() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();

    return `cinta-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }

  function publishShopifyCheckoutEvent(payload) {
    try {
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish("cinta_begin_checkout", payload);
      }
    } catch (_error) {
      // Analytics must never block checkout.
    }
  }

  function pushBeginCheckoutDataLayer(payload) {
    if (!Array.isArray(window.dataLayer)) return false;

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: "begin_checkout", ecommerce: payload });
    return true;
  }

  function sendBeginCheckoutGtag(payload) {
    if (typeof window.gtag !== "function") return false;

    window.gtag("event", "begin_checkout", payload);
    return true;
  }

  async function trackBeginCheckout(cart, selectedOption) {
    const fingerprint = buildEventFingerprint(cart, selectedOption);
    const existingEvent = inFlightEvents.get(fingerprint);
    if (existingEvent) return existingEvent;

    const trackingPromise = trackBeginCheckoutOnce(cart, selectedOption);
    inFlightEvents.set(fingerprint, trackingPromise);

    try {
      return await trackingPromise;
    } finally {
      inFlightEvents.delete(fingerprint);
    }
  }

  async function trackBeginCheckoutOnce(cart, selectedOption) {
    const payload = buildBeginCheckoutPayload(cart, selectedOption);
    const shopifyPayload = Object.assign({}, payload, { event_id: createEventId() });
    publishShopifyCheckoutEvent(shopifyPayload);

    const sent = sendBeginCheckoutGtag(payload) || pushBeginCheckoutDataLayer(payload);
    if (!sent) return;

    await new Promise((resolve) => window.setTimeout(resolve, 300));
  }

  window.CintaAnalytics = Object.assign({}, window.CintaAnalytics, {
    trackBeginCheckout,
  });
})();
